



























import { defineComponent, PropType } from "@vue/composition-api";
import { TranslateResult } from "vue-i18n";
import { getElement } from "@/lib/elementHelpers";

export default defineComponent({
  name: "BaseCheckbox",
  props: {
    value: { type: Boolean, default: false },
    name: { type: String, default: "checkbox" },
    disabled: { type: Boolean, default: false },
    hideIcon: { type: Boolean, default: false },
    checkedBoxColor: { type: String, default: "var(--palette-gray-lighten-7)" },
    label: { type: String as PropType<string | TranslateResult>, default: "" },
  },
  methods: {
    click() {
      (getElement(this.$refs.checkbox) as HTMLInputElement).click();
    },
  },
});
